export function normalizeDisciplineSystem(data) {
  if (!data) {
    return null;
  }

  return {
    gradingSystemType: data.disciplineSystemType,
    qualitativeLevels: data.disciplineQualitativeLevels ?? [],
    numericMin: data.disciplineNumericMin,
    numericMax: data.disciplineNumericMax,
  };
}
